/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deleteRider } from '../fn/riders/delete-rider';
import { DeleteRider$Params } from '../fn/riders/delete-rider';
import { racesRaceGuidRidersPost } from '../fn/riders/races-race-guid-riders-post';
import { RacesRaceGuidRidersPost$Params } from '../fn/riders/races-race-guid-riders-post';
import { Rider } from '../models/rider';
import { ridersOnlyReportable } from '../fn/riders/riders-only-reportable';
import { RidersOnlyReportable$Params } from '../fn/riders/riders-only-reportable';
import { setHandled } from '../fn/riders/set-handled';
import { SetHandled$Params } from '../fn/riders/set-handled';
import { setUnhandled } from '../fn/riders/set-unhandled';
import { SetUnhandled$Params } from '../fn/riders/set-unhandled';

@Injectable({ providedIn: 'root' })
export class RidersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `ridersOnlyReportable()` */
  static readonly RidersOnlyReportablePath = '/races/{raceGuid}/onlyreportable/{onlyReportable}/riders';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ridersOnlyReportable()` instead.
   *
   * This method doesn't expect any request body.
   */
  ridersOnlyReportable$Response(params: RidersOnlyReportable$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Rider>>> {
    const obs = ridersOnlyReportable(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ridersOnlyReportable$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ridersOnlyReportable(params: RidersOnlyReportable$Params, context?: HttpContext): Observable<Array<Rider>> {
    const resp = this.ridersOnlyReportable$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<Rider>>): Array<Rider> => r.body)
    );
  }

  /** Path part for operation `setHandled()` */
  static readonly SetHandledPath = '/races/{raceGuid}/riders/{riderGuid}/sethandled';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setHandled()` instead.
   *
   * This method doesn't expect any request body.
   */
  setHandled$Response(params: SetHandled$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = setHandled(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setHandled$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  setHandled(params: SetHandled$Params, context?: HttpContext): Observable<void> {
    const resp = this.setHandled$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `setUnhandled()` */
  static readonly SetUnhandledPath = '/races/{raceGuid}/riders/{riderGuid}/setunhandled';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setUnhandled()` instead.
   *
   * This method doesn't expect any request body.
   */
  setUnhandled$Response(params: SetUnhandled$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = setUnhandled(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setUnhandled$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  setUnhandled(params: SetUnhandled$Params, context?: HttpContext): Observable<void> {
    const resp = this.setUnhandled$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `racesRaceGuidRidersPost()` */
  static readonly RacesRaceGuidRidersPostPath = '/races/{raceGuid}/riders';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `racesRaceGuidRidersPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  racesRaceGuidRidersPost$Response(params: RacesRaceGuidRidersPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Rider>>> {
    const obs = racesRaceGuidRidersPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `racesRaceGuidRidersPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  racesRaceGuidRidersPost(params: RacesRaceGuidRidersPost$Params, context?: HttpContext): Observable<Array<Rider>> {
    const resp = this.racesRaceGuidRidersPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<Rider>>): Array<Rider> => r.body)
    );
  }

  /** Path part for operation `deleteRider()` */
  static readonly DeleteRiderPath = '/rider';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteRider()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteRider$Response(params: DeleteRider$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteRider(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteRider$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteRider(params: DeleteRider$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteRider$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
